import { ReactNode } from 'react'

import { StaticImageData } from 'next/image'

import {
  Point001Image,
  Point002Image,
  Point003Image,
  Point004Image,
} from 'Assets/Images/Sections/MembershipPointsSection'

import { MEMBERSHIPS_CORPORATE } from 'Constants/Paths'

export type MembershipPointsItem = {
  id: string
  backgroundImage: StaticImageData
  backgroundImageAlt: string
  buttonCaption?: string
  link?: string
  plainText: ReactNode
  title: string
  subtitle: string
}

export const MEMBERSHIP_POINTS_ITEMS: MembershipPointsItem[] = [
  {
    id: 'MembershipPointsItem-001',
    plainText: (
      <>
        Beyond the extensive networking opportunities available to you, we also
        offer the chance for hole sponsorships and event naming rights, as well
        as social media and EDM promotional opportunities throughout the year to
        connect with more clients.
      </>
    ),
    backgroundImage: Point001Image,
    backgroundImageAlt: '',
    buttonCaption: 'Talk To Us',
    title: 'Build Brand Awareness',
    subtitle: 'Promote your brand in a native and natural way.',
  },
  {
    id: 'MembershipPointsItem-002',
    plainText: (
      <>
        Mingle with some of the best business leaders in Australia and hear from
        regular keynote speakers to develop your own business and leadership
        skills, build a positive corporate culture and grow your organisation.
      </>
    ),
    buttonCaption: 'Apply Now',
    backgroundImage: Point002Image,
    backgroundImageAlt: '',
    title: 'Enjoy Leadership Development',
    subtitle: 'Learn from the best to become a better business leader.',
  },
  {
    id: 'MembershipPointsItem-003',
    plainText: (
      <>
        As a company-wide corporate membership, you can provide multiple members
        of your team the opportunity to play golf and network with successful
        business executives on a regular basis, helping to develop their skills
        for the benefit of your organisation.
      </>
    ),
    buttonCaption: 'Explore Our Memberships',
    backgroundImage: Point003Image,
    backgroundImageAlt: '',
    link: MEMBERSHIPS_CORPORATE,
    title: 'Encourage Team Building',
    subtitle: 'Engage your people and foster stronger team connections.',
  },
  {
    id: 'MembershipPointsItem-004',
    plainText: (
      <>
        Step out of the office, get active and enjoy the fresh air while
        entertaining your clients or key members of your team with a round of
        golf – all while networking with successful C-Suite executives and
        business owners from around the country.
      </>
    ),
    buttonCaption: 'Apply Now',
    backgroundImage: Point004Image,
    backgroundImageAlt: '',
    title: 'Promote Enhanced Wellbeing',
    subtitle: 'Boost morale and wellness among your team and clients.',
  },
]
